<template>
    <div class="c-panel c-panel--border c-panel--expand margin-b-24">
        <template v-if="request.is_tolk_opdracht">
            <h3 class="margin-b-8">Afronden tolkdienst</h3>
            <div class="fs-small">Laat je opdracht aftekenen</div>
            <button class="c-btn c-btn--secondary c-btn--expanded margin-b-8 margin-t-24" @click="modal = true ">Opdracht aftekenen</button>

            <c-complete-service
    			v-show="modal"
                :request="request"
                @submit="submit"
    			@close="modal = false">
    		</c-complete-service>
        </template>

        <template v-if="request.is_tolk_opdracht == 0">
            <h3 class="margin-b-8">Afronden vertaaldienst</h3>
            <div class="fs-small">Door je opdracht af te ronden ontvangt de planner je bestanden.</div>

            <c-form ref="form" class="margin-t-16" @valid="submit" :autocomplete="'off'">

                <c-form-element
                    :label="'Aantal woorden'">
                    <input type="number" required v-model="aantal_woorden" name="number-words" />
                </c-form-element>

                <c-form-element
                    :label="'Aantal beëdigingen'">
                    <input type="number" v-model="aantal_beedigingen" name="number-sworn-in" />
                </c-form-element>

                <button type="submit" class="c-btn c-btn--secondary c-btn--expanded margin-b-8 margin-t-24" ref="submit">Opdracht afronden</button>

            </c-form>
        </template>
    </div>
</template>

<script>
import Form from '@mixins/Form';
import CCompleteService from '@app/modals/CompleteService';

export default {
    components: { CCompleteService },
    mixins: [ Form ],
    props: {
        request: {
            type: Object
        },
        assignment: {
            type:Object
        }
    },
    data() {
        return {
            modal: false,
            aantal_woorden: '',
            aantal_beedigingen: ''
        }
    },
    methods: {
        submit(data) {
            let params = {
                opdracht: this.assignment.id
            };

            if ( this.request.is_tolk_opdracht ) {
                params = { ...params, ...data};
            }
            else {
                params.aantal_woorden = this.aantal_woorden;
                params.aantal_beedigingen = this.aantal_beedigingen || 0;
            }

            this.$xhr.post('/api/request-detail/' + this.$route.params.id + '/finish/', params).then( () => {

                this.$store.dispatch('request/changeAssignment', {
                    id: this.assignment.id,
                    klaar_at: this.$options.filters.datestring(new Date()),
                    ...params
                });
                this.$emit('completed');

            }).catch( () => {
                this.$store.dispatch('toasts/alert', {title: 'Opdracht afronden', text: 'Helaas konden we de opdracht niet afronden'});
            })
        }
    }
}
</script>
